import React from 'react';

import { PoliciesPagesType } from 'enums/curo/PoliciesPagesTypes';
import { getSignInProcessState } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import CuroAuthorizedLayout from 'layout/CuroAuthorizedLayout';
import CuroMainLayout from 'layout/CuroMainLayout';

import ConsentOfESignatures from './content/ConsentOfESignatures';
import Disclosures from './content/Disclosures';
import GeneralContent from './content/GeneralContent';
import OnlinePrivacyPolicy from './content/OnlinePrivacyPolicy';
import TermsOfUse from './content/TermsOfUse';

type PoliciesProps = {
  type: PoliciesPagesType;
};

const PoliciesPage = ({ type }: PoliciesProps) => {
  const { accountData } = useAppSelector(getSignInProcessState);

  const shouldShowAuthorizedPage = accountData;

  const renderContent = () => {
    switch (type) {
      case PoliciesPagesType.General:
        return <GeneralContent />;
      case PoliciesPagesType.Disclosures:
        return <Disclosures />;
      case PoliciesPagesType.ConsentForElectronicSignatures:
        return <ConsentOfESignatures withBackButton={true} />;
      case PoliciesPagesType.OnlinePrivacyPolicy:
        return <OnlinePrivacyPolicy />;
      case PoliciesPagesType.TermsOfUse:
        return <TermsOfUse />;
    }
  };

  const renderPage = () => {
    if (shouldShowAuthorizedPage) {
      return <CuroAuthorizedLayout>{renderContent()}</CuroAuthorizedLayout>;
    }

    return <CuroMainLayout>{renderContent()}</CuroMainLayout>;
  };

  return renderPage();
};

export default PoliciesPage;
